import { Effect, Schema } from 'effect';

// ── Request DTOs ────────────────────────────────────────────

export const PostLoginRequest = Schema.Struct({
  email: Schema.String,
  password: Schema.String,
  fcm_token: Schema.optional(Schema.NullOr(Schema.String)),
});

export const PostRegisterRequest = Schema.Struct({
  email: Schema.String,
  password: Schema.optional(Schema.NullOr(Schema.String)),
  signup_language: Schema.optional(Schema.Literals(['en', 'es'])),
  fcm_token: Schema.optional(Schema.NullOr(Schema.String)),
  firebase_id_token: Schema.optional(Schema.NullOr(Schema.String)),
  price_id: Schema.optional(Schema.NullOr(Schema.String)),
  promo_code: Schema.optional(Schema.NullOr(Schema.String)),
  trial_period_days: Schema.optional(Schema.NullOr(Schema.Int)),
  // Analytics fields
  facebook_click_cookie: Schema.optional(Schema.NullOr(Schema.String)),
  facebook_click_id: Schema.optional(Schema.NullOr(Schema.String)),
  facebook_pixel_cookie: Schema.optional(Schema.NullOr(Schema.String)),
  google_click_id: Schema.optional(Schema.NullOr(Schema.String)),
  utm_campaign: Schema.optional(Schema.NullOr(Schema.String)),
  utm_content: Schema.optional(Schema.NullOr(Schema.String)),
  utm_medium: Schema.optional(Schema.NullOr(Schema.String)),
  utm_source: Schema.optional(Schema.NullOr(Schema.String)),
  utm_term: Schema.optional(Schema.NullOr(Schema.String)),
});

// ── Response DTOs ───────────────────────────────────────────

/**
 * The generated client had `_id` but the actual legacy API returns `id`.
 * @see user-endpoints.ts for full explanation
 */
export const PostLogin200 = Schema.Struct({
  Authorization: Schema.String,
  id: Schema.String,
  email: Schema.String,
  status: Schema.String,
  firebase_custom_token: Schema.String,
  referral_code: Schema.String,
  onboardingStatus: Schema.NullOr(Schema.String),
  country_code: Schema.NullOr(Schema.String).pipe(
    Schema.withDecodingDefaultType(Effect.succeed(null)),
  ),
  fcm_token: Schema.NullOr(Schema.String).pipe(
    Schema.withDecodingDefaultType(Effect.succeed(null)),
  ),
});

export const PostRegister200 = Schema.Struct({
  Authorization: Schema.String,
  id: Schema.String,
  email: Schema.String,
  status: Schema.String,
  firebase_custom_token: Schema.String,
  referral_code: Schema.String,
  country_code: Schema.NullOr(Schema.String).pipe(
    Schema.withDecodingDefaultType(Effect.succeed(null)),
  ),
  fcm_token: Schema.NullOr(Schema.String).pipe(
    Schema.withDecodingDefaultType(Effect.succeed(null)),
  ),
  client_secret: Schema.NullOr(Schema.String).pipe(
    Schema.withDecodingDefaultType(Effect.succeed(null)),
  ),
  customer_id: Schema.NullOr(Schema.String).pipe(
    Schema.withDecodingDefaultType(Effect.succeed(null)),
  ),
  random_password: Schema.NullOr(Schema.String).pipe(
    Schema.withDecodingDefaultType(Effect.succeed(null)),
  ),
});

// ── Summary nested types ────────────────────────────────────

export const UserMetering = Schema.Struct({
  has_active_referral_subscription: Schema.Boolean,
  has_active_stripe_subscription: Schema.Boolean,
  // Defaulted on decode so a summary persisted by an older client build
  // (mobile's offline account snapshot) still decodes after this field landed.
  has_active_rc_subscription: Schema.Boolean.pipe(
    Schema.withDecodingDefaultType(Effect.succeed(false)),
  ),
  is_active_subscription: Schema.Boolean,
});

export const UserOnboarding = Schema.Struct({
  is_complete: Schema.Boolean,
});

export const UserPreferences = Schema.Struct({
  voice: Schema.String,
  most_recent_language: Schema.optional(Schema.Literals(['en', 'es'])),
});

export const UserProfile = Schema.Struct({
  first_name: Schema.NullOr(Schema.String),
  last_name: Schema.NullOr(Schema.String),
});

export const GetSummary200 = Schema.Struct({
  id: Schema.String,
  email: Schema.String,
  created_at: Schema.NullOr(Schema.DateFromString).pipe(
    Schema.withDecodingDefaultType(Effect.succeed(null)),
  ),
  metering: UserMetering,
  onboarding: UserOnboarding,
  preferences: UserPreferences,
  profile: UserProfile,
  country_code: Schema.NullOr(Schema.String).pipe(
    Schema.withDecodingDefaultType(Effect.succeed(null)),
  ),
  firebase_custom_token: Schema.NullOr(Schema.String).pipe(
    Schema.withDecodingDefaultType(Effect.succeed(null)),
  ),
  firebase_uid: Schema.NullOr(Schema.String).pipe(
    Schema.withDecodingDefaultType(Effect.succeed(null)),
  ),
  referral_code: Schema.NullOr(Schema.String).pipe(
    Schema.withDecodingDefaultType(Effect.succeed(null)),
  ),
  referred_by: Schema.NullOr(Schema.String).pipe(
    Schema.withDecodingDefaultType(Effect.succeed(null)),
  ),
});
